import ApplicationReviewersTab from './application-reviewers.vue'
import CertificateManagersTab from './certificate-managers.vue'
import FollowUpManagersTab from './follow-up-managers.vue'
import AuditTeamTab from './audit-team.vue'

const ASSIGN_PERSONAL_TABS = [
  {
    key: 'application-reviewers',
    label: 'Application Reviewers',
    icon: 'UserCheckIcon',
    component: ApplicationReviewersTab,
  },
  {
    key: 'certificate-managers',
    label: 'Certificate Managers',
    icon: 'AwardIcon',
    component: CertificateManagersTab,
  },
  {
    key: 'follow-up-managers',
    label: 'Follow up and coordination department manager',
    icon: 'Share2Icon',
    component: FollowUpManagersTab,
  },
  {
    key: 'audit-team',
    label: 'Audit Team',
    icon: 'ShieldIcon',
    component: AuditTeamTab,
  },
]

export default ASSIGN_PERSONAL_TABS
